import './index.css';

import React from 'react';
import { render } from 'react-dom';

import App from './App';
import AppIE from './AppIE';
import AppMatt from './AppMatt';
if (document.location.hash == '#IE') {
  render(<AppIE />, document.querySelector('#app'));
} else if (document.location.hash == '#MATT') {
  render(<AppMatt />, document.querySelector('#app'));
} else {
  render(<App />, document.querySelector('#app'));
}
